import { Grid,Box,Typography } from "@mui/material"
import ItemServices from "../items_services/ItemServices"
import Heading from "../../common/Heading"

export const ShareRateCard = () => {
    return (
      <Box
        px={{ xs: 2, sm: 4 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Heading name="Share Rate Card" />

        {/* <Grid
                item
                xs={12}
                sx={{
                    background:
                        "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                    padding: "10px",
                    mt: "10px",
                    borderRadius: "5px",
                    color: "#01008B",
                    textAlign: "left",
                    marginBottom: "20px",
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "20px",
                    fontWeight: 500,
                }}
            >
                <Typography
                    variant="h6"
                     sx= {{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                >
                    Share Rate Card
                </Typography>
            </Grid> */}
        <ItemServices
          config={{ addBtn: false, isCheckBox: true, message: true }}
        />
      </Box>
    );
}